import { Events, emit } from './store-events.js';
import { BaseInteractiveElement } from './component-base.js';

class VariantPickerElement extends BaseInteractiveElement {
  constructor() {
    super({ baseClass: 'variant-picker' });
  }

  connectedCallback() {
    super.connectedCallback();
    try {
      this.#onChange = this.#onChange.bind(this);
      this.addEventListener('change', this.#onChange);
      // Initial sync on connect
      this.#applyFromInputs();
    } catch (_) {}
  }

  disconnectedCallback() {
    try { this.removeEventListener('change', this.#onChange); } catch (_) {}
    super.disconnectedCallback();
  }

  #getVariants() {
    try {
      const json = this.querySelector('script[data-product-variants]');
      if (!json || !json.textContent) return [];
      return JSON.parse(json.textContent);
    } catch (_) { return []; }
  }

  #collectSelectedOptions() {
    const inputs = Array.from(this.querySelectorAll('[data-option-index]'));
    inputs.sort((a, b) => Number(a.getAttribute('data-option-index')) - Number(b.getAttribute('data-option-index')));
    return inputs.map((el) => {
      if (el instanceof HTMLInputElement) {
        if (el.type === 'radio') {
          if (!el.checked) return null;
          return el.value;
        }
        return el.value;
      }
      if (el instanceof HTMLSelectElement) {
        return el.options[el.selectedIndex]?.value;
      }
      return null;
    }).filter((v) => v != null);
  }

  #findMatch(selected) {
    const variants = this.#getVariants();
    return variants.find((v) => {
      try { return JSON.stringify(v.options) === JSON.stringify(selected); } catch (_) { return false; }
    }) || null;
  }

  #onChange(ev) {
    try {
      this.#applyFromInputs();
    } catch (_) {}
  }

  #applyFromInputs() {
    const selected = this.#collectSelectedOptions();
    const match = this.#findMatch(selected);
    const productId = this.getAttribute('data-product-id') || undefined;

    // Update hidden input and ATC state inside nearest product form
    const container = this.closest('.shopify-section, dialog, [data-section], form, div') || document;
    const form = container.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"], form');
    const idInput = form && form.querySelector('input[name="id"]');
    const atc = form && form.querySelector('[data-role="add-to-cart"], button[type="submit"]');

    if (match) {
      if (idInput) try { idInput.value = String(match.id); } catch (_) {}
      if (atc) try { atc.disabled = !match.available; } catch (_) {}
      // Update URL on product page
      try {
        if (document.body && document.body.dataset && document.body.dataset.template && document.body.dataset.template.includes('product')) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', String(match.id));
          window.history.replaceState({}, '', url.toString());
        }
      } catch (_) {}
      emit(Events.variant.selected, { optionValues: selected, productId, variantId: match.id }, this);
      emit(Events.variant.update, { variant: match, productId }, this);
    } else {
      // No exact match (e.g., partial selection) → disable ATC until resolved
      if (atc) try { atc.disabled = true; } catch (_) {}
      emit(Events.variant.selected, { optionValues: selected, productId, variantId: null }, this);
    }
  }
}

try {
  const TAG = 'variant-picker';
  if (!customElements.get(TAG)) customElements.define(TAG, VariantPickerElement);
} catch (_) {}


